/**
 * MessageReply Component
 * Preview del messaggio a cui si risponde
 */

import { memo } from 'react';

interface MessageReplyProps {
  replyToBody?: string;
  isOutbound?: boolean;
  className?: string;
}

export const MessageReply = memo(function MessageReply({
  replyToBody,
  isOutbound = false,
  className = '',
}: MessageReplyProps) {
  if (!replyToBody) return null;

  return (
    <div
      className={`
        px-3 py-2 mb-1 rounded-lg
        border-l-2 border-[#2383E2]
        ${isOutbound
          ? 'bg-[rgba(255,255,255,0.2)]'
          : 'bg-[rgba(55,53,47,0.04)] dark:bg-white/5'
        }
        ${className}
      `}
    >
      <p className="text-xs text-[#787774] line-clamp-2">
        {replyToBody}
      </p>
    </div>
  );
});
